// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"email-tag__gradient-bg5__fMhq1","tagItem":"email-tag__tagItem__l3EIY"};